<script>
    import { _ } from '../services/i18n'
    export let sceneId = -1;
    export let orderId = -1;
    export let optionalText = "";
    export let styleVariant = "";
    export let align = "left";

    import config from "../config";

    let src = "";
    if (sceneId === -1 || orderId === -1) {
        src = "/scenes/ar-demo-scene/Arianne_comp.gltf";
    }
    
</script>

{#if config.ar?.enabled}
    <div class={`btn-container align-${align}`}>
        <a class={`ARButton variant-${styleVariant}`} href={`/ar-viewer.html?src=/api/v1/gltfscene/${orderId}/${sceneId}/scene.gltf`} target="_blank" rel="noreferrer">
            {optionalText}  <img src="/icons/ar-viewer-logo.svg" class="ar-viewer-logo" alt="AR viewer">
        </a>
    </div>
{/if}

<style>
    .btn-container {
        width: fit-content;
        position: relative;
        float: left;
    }

    .btn-container.align-left {
        float: left;
    }

    .btn-container.align-right {
        float: right;
    }
    
    .ARButton.variant-small {
        float: left;
        margin: 5px 0px 5px 4px;
        border-radius: 5px;
        background-color: var(--theme-color-1);
        color: #fff;
        border: 0 none;
        padding: 2px 7px;
        text-align: center;
        width: fit-content;
        position: relative;
        transition: all 0.25s ease-in-out;
        font-size: 8px;
    }

    .ARButton.variant-medium {
        float: right;
        margin: 5px;
        border-radius: 50%;
        background-color: var(--theme-color-1);
        color: #fff;
        border: 0 none;
        padding: 2px 7px;
        text-align: center;
        width: 46px;
        height: 46px;
        position: relative;
        transition: all 0.25s ease-in-out;
    }

    .ARButton.variant-small img.ar-viewer-logo {
        width: 18px !important;
        height: 18px !important;
        border: none;
    }

    .ARButton.variant-medium img.ar-viewer-logo {
        width: 33px !important;
        height: 33px !important;
        border: none;
        margin-top: 5px;
    }

    .ARButton.variant-small:hover {
        background-color: var(--theme-color-4);
        color: #fff;
    }

    .ARButton.variant-medium:hover {
        background-color: var(--theme-color-4);
        -webkit-animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        color: #fff;
    }

    .ARButton.variant-small:hover:before {
        background-color: var(--theme-color-4);
    }

    .ARButton.variant-medium:hover:before {
        background-color: var(--theme-color-4);
        -webkit-animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
    }
        
    .ARButton.variant-small:hover:after {
        background-color: var(--theme-color-4);
    }

    .ARButton.variant-medium:hover:after {
        background-color: var(--theme-color-4);
        -webkit-animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;
        animation: svelte-1dspmwl-AddToCartButton-beat 1.5s ease-out infinite;

    }

    .ARButton:before,
    .ARButton:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--theme-color-1);
        width: 100%;
        height: 100%;
        border-radius: 5px;
        opacity: 0;
        transition: all 0.25s ease-in-out;
    }
    a:hover {
        text-decoration: none;
    }
    @-webkit-keyframes ARButton-beat {
        0% {
            opacity: 0.8;
            transform: scale(1);
        }
        70% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes ARButton-beat {
        0% {
            opacity: 0.8;
            transform: scale(1);
        }
        70% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 0;
        }
    }
</style>

<svelte:head>
    <script src="https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js" integrity="sha512-BNaRQnYJYiPSqHHDb58B0yaPfCu+Wgds8Gp/gU33kqBtgNS4tSPHuGibyoeqMV/TJlSKda6FXzoEyYGjTe+vXA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
</svelte:head>